import { PocButton } from 'commons/components/components-wrapper/poc-button.component';
import { PocProgressSpinner } from 'commons/components/components-wrapper/poc-progress-spinner.component';
import { PocTypography } from 'commons/components/components-wrapper/poc-typography.component';
import { useTranslation } from 'core/i18n/i18n';
import {
    SettingsLoadingContainer,
    SettingsViewContent,
    SettingsViewHeader,
    SettingsViewLayout,
    TitleWithOptions,
} from 'modules/settings/settings.style';
import { Rule } from '../types/automation-rules.type';
import { AutomationRulesListComponent } from './automation-rules-list.component';

interface AutomationRulesLayoutProps {
    isLoading: boolean;
    rules: Rule[];
    onCreateOptionHandler: VoidFunction;
    onEditOptionHandler: (id: string) => void;
    onEnableChange: (id: string) => void;
}

export const AutomationRulesLayout = (props: AutomationRulesLayoutProps) => {
    const { isLoading, rules, onCreateOptionHandler, onEditOptionHandler, onEnableChange } = props;
    const { t } = useTranslation();
    return (
        <SettingsViewLayout>
            <SettingsViewHeader>
                <TitleWithOptions>
                    <PocTypography element="h5" variant="title5">
                        {t('settings.system.automation-rules.list.header.title')}
                    </PocTypography>
                    <PocButton variant="secondary" size="medium" onClick={onCreateOptionHandler}>
                        {t('settings.system.automation-rules.actions.new')}
                    </PocButton>
                </TitleWithOptions>
                <PocTypography element="p" variant="body1">
                    {t('settings.system.automation-rules.list.header.description')}
                </PocTypography>
            </SettingsViewHeader>
            <SettingsViewContent>
                {isLoading ? (
                    <SettingsLoadingContainer>
                        <PocProgressSpinner variant="primary" size="large" />
                    </SettingsLoadingContainer>
                ) : (
                    <AutomationRulesListComponent
                        rules={rules}
                        onEnableChange={onEnableChange}
                        onEditOptionHandler={onEditOptionHandler}
                    />
                )}
            </SettingsViewContent>
        </SettingsViewLayout>
    );
};
